module.exports = __webpack_public_path__ + "static/media/Elf-Selected.6ceeaaf5.png";